import(/* webpackMode: "eager" */ "/home/runner/work/juchats-share/juchats-share/app/style/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/home/runner/work/juchats-share/juchats-share/component/theme-provider.tsx");
